import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en.json';
import nlTranslation from './locales/nl.json';
import frTranslation from './locales/fr.json';
import deTranslation from './locales/de.json';
import itTranslation from './locales/it.json';
import esTranslation from './locales/es.json';
import ptTranslation from './locales/pt.json';

const resources = {
    en: { translation: enTranslation },
    nl: { translation: nlTranslation },
    fr: { translation: frTranslation },
    de: { translation: deTranslation },
    it: { translation: itTranslation },
    es: { translation: esTranslation },
    pt: { translation: ptTranslation }
};

i18n
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
        resources,
        fallbackLng: 'en', // Use English if detected language is not available
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false // React already escapes values
        },

        detection: {
            // Order of language detection:
            // 1. localStorage (set manually by user or saved preference)
            // 2. navigator (browser language)
            // 3. htmlTag (html lang attribute)
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'], // Cache the selected language
            lookupLocalStorage: 'i18nextLng'
        }
    });

export default i18n;
